import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (!loading) return null;

    return (
        <div className="loading-screen">
            <div className="loading-content">
                <div className="loading-logo">
                    <svg width="120" height="120" viewBox="0 0 100 100">
                        <defs>
                            <linearGradient id="loadingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style={{stopColor: '#0e2d1d', stopOpacity: 1}} />
                                <stop offset="100%" style={{stopColor: '#25D366', stopOpacity: 1}} />
                            </linearGradient>
                        </defs>
                        
                        <circle 
                            cx="50" 
                            cy="50" 
                            r="45" 
                            fill="none" 
                            stroke="url(#loadingGradient)" 
                            strokeWidth="3"
                            className="loading-circle"
                            strokeDasharray="283"
                            strokeDashoffset="283"
                        />
                        
                        <circle cx="50" cy="50" r="35" fill="none" stroke="url(#loadingGradient)" strokeWidth="1" opacity="0.5"/>
                        
                        <g transform="translate(50, 50)">
                            <path 
                                d="M -20,-10 L -15,10 L -10,8 L -15,-8 Z" 
                                fill="url(#loadingGradient)"
                                className="blade-animate"
                            />
                            <path 
                                d="M 20,-10 L 15,10 L 10,8 L 15,-8 Z" 
                                fill="url(#loadingGradient)"
                                className="blade-animate"
                            />
                            <circle cx="0" cy="0" r="4" fill="#25D366" className="pivot-pulse"/>
                            
                            <line x1="-8" y1="-15" x2="-8" y2="-20" stroke="#25D366" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="8" y1="-15" x2="8" y2="-20" stroke="#25D366" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="0" y1="-18" x2="0" y2="-23" stroke="#0e2d1d" strokeWidth="2" strokeLinecap="round"/>
                        </g>
                    </svg>
                </div>
                <h2 className="loading-text">مركز بالي طلاسو</h2>
                <div className="loading-bar">
                    <div className="loading-progress"></div>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;
